import { FormattedMessage } from "react-intl";

import { StyledEventSummaryList, StyledEventSummaryListItem } from "./styles";
import { EventSummaryListProps } from "./types";

const EventSummaryList: React.FC<EventSummaryListProps> = ({
  items,
  count,
  isAll,
}) => {
  const itemsCount = items?.length || 0;
  const totalCount = count || 0;
  const moreCount = totalCount > itemsCount ? totalCount - itemsCount + 1 : 0;
  const sliceEnd = moreCount ? itemsCount - 1 : undefined;

  return (
    <StyledEventSummaryList>
      {isAll ? (
        <FormattedMessage defaultMessage="All Events" />
      ) : (
        <>
          {items?.slice(0, sliceEnd).map(({ id, name }) => (
            <StyledEventSummaryListItem key={id}>
              {name}
            </StyledEventSummaryListItem>
          ))}
          {moreCount > 0 && (
            <FormattedMessage
              defaultMessage="and {count} more"
              values={{ count: moreCount }}
            />
          )}
        </>
      )}
    </StyledEventSummaryList>
  );
};

export default EventSummaryList;
